import { createError } from 'h3'
import { requestOrThrow } from '../api-client'
import { useCustomFetch, type ResponseError } from '../custom-fetch'
import type { PostAuthSignIn200 } from '~/types/api/Auth'
import type { CamelCaseKeys } from '~/types/util'

type SignInApiResponse = CamelCaseKeys<PostAuthSignIn200>

interface SignUpValidationBody {
  name?: string
  nameRuby?: string
  prefectures?: string
  municipalities?: string
  street?: string
  address?: string
  building?: string
  municipalitiesRuby?: string
  streetRuby?: string
  addressRuby?: string
  buildingRuby?: string
}

export function signIn(signInId: string, password: string) {
  return requestOrThrow<SignInApiResponse>('auth/sign_in', {
    method: 'POST',
    body: { signInId, password },
  })
}

export async function validateSignUpAttributes(body: SignUpValidationBody) {
  const { error } = await useCustomFetch('auth/sign_up', {
    method: 'POST',
    body,
  })

  if (error.value?.statusCode === 422) return error.value as ResponseError

  throw createError({
    statusCode: error.value!.statusCode,
    message: error.value!.message,
    data: error.value!.data,
    fatal: true,
  })
}

export function deleteMe(sessionId: string) {
  return requestOrThrow<unknown>('me', {
    method: 'DELETE',
    headers: { Authorization: `Bearer ${sessionId}` },
  })
}

export function forgotPasswordRequest(signInId: string) {
  return requestOrThrow<unknown>('/auth/forgot_password', {
    method: 'POST',
    body: { signInId },
  })
}

export function confirmForgotPasswordRequest(
  signInId: string,
  newPassword: string,
  resetToken?: string
) {
  return requestOrThrow<unknown>('/auth/confirm_forgot_password', {
    method: 'POST',
    body: { signInId, newPassword, resetToken },
  })
}

export function signOutRequest(sessionId: string) {
  return requestOrThrow<unknown>('auth/sign_out', {
    method: 'DELETE',
    headers: { Authorization: `Bearer ${sessionId}` },
  })
}
